import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import { Button } from '@utilitywarehouse/hearth-react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';

import './styles.scss';

const InLifeExitDialog = () => {
  const dialog = useDialog(DialogID.IN_LIFE_EXIT);

  const handleCancel = () => dialog.setOpen(false);

  const handleExit = () => {
    clearInLifeOrderAndRedirectToMyAccount();
  };

  return (
    <Dialog
      id={dialog.id}
      data-testid="inlife-exit-dialog"
      onClose={handleCancel}
      heading="Are you sure you want to exit?"
      description="If you leave now, you’ll lose your progress."
    >
      <DialogActions className="inLifeExitDialog__actions">
        <Button
          type="button"
          variant="ghost"
          data-testid="inlife-exit-cancel-button"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="solid"
          colorScheme="destructive"
          data-testid="inlife-exit-exit-button"
          onClick={handleExit}
        >
          Exit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { InLifeExitDialog };
